/* eslint-disable max-classes-per-file */
import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import PropTypes from "prop-types";

import { Option } from "Cobalt/Dropdown";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("MenuItem");

export interface MenuItemProps {
  itemType: "default" | "dropdown" | "filter";
  eventKey: any;
  children: React.ReactNode;
  href?: string;
  className?: string;
  onSelect?: (eventKey: any) => void;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export class MenuItem extends React.Component<MenuItemProps> {
  handleNavigation = (url: string) => {
    window.location.href = url;
  };

  render() {
    const { itemType, eventKey, children, href, className, onSelect, onClick, ...rest } = this.props;
    const itemTypeClass = isIntuit() ? `intuit-${itemType}` : itemType;
    const combinedClassName = classnames(bem(), bem(null, itemTypeClass), className);

    return (
      <Option value={eventKey} onSelect={onSelect} onClick={this.handleClick} className={combinedClassName} componentClass="div" severity={itemType} {...rest}>
        {children}
      </Option>
    );
  }

  handleClick = (e) => {
    const { onSelect, onClick, eventKey, href } = this.props;
    e.preventDefault();

    if (onSelect) {
      onSelect(eventKey);
    }

    if (this.context.onMenuSelect) {
      this.context.onMenuSelect(eventKey);
    }

    if (onClick) {
      onClick(e);
    } else if (href) {
      this.handleNavigation(href);
    }
  };
}

MenuItem.contextTypes = {
  onMenuSelect: PropTypes.func,
};

MenuItem.propTypes = {
  itemType: PropTypes.oneOf(["default", "dropdown", "filter"]),
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  eventKey: PropTypes.any,
  href: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

MenuItem.defaultProps = {
  itemType: "default",
};

export interface TopMenuItemProps {
  eventKey?: any;
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export class TopMenuItem extends React.Component<TopMenuItemProps> {
  handleNavigation = (url: string) => {
    window.location.href = url;
  };

  render() {
    const { eventKey, children, href, className, onClick, ...rest } = this.props;

    return (
      <li role="presentation" className={className}>
        <a href={href || "#"} role="menuitem" tabIndex={-1} onClick={this.handleClick} {...rest}>
          {children}
        </a>
      </li>
    );
  }

  handleClick = (e) => {
    const { onClick, href } = this.props;

    if (onClick) {
      e.preventDefault();
      onClick(e);
    } else if (href) {
    } else {
      e.preventDefault();
    }
  };
}

TopMenuItem.propTypes = {
  eventKey: PropTypes.any,
  onClick: PropTypes.func,
  href: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export interface CompactMenuItemProps {
  itemType: "default" | "dropdown" | "filter";
  eventKey: any;
  children: React.ReactNode;
  className?: string;
  onSelect?: (eventKey: any) => void;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  currentSort: any;
}

export class CompactMenuItem extends React.Component<CompactMenuItemProps> {
  render() {
    const { itemType, eventKey, children, className, onSelect, onClick, currentSort, ...rest } = this.props;
    const combinedClassName = classnames("flex flex-row justify-start text-left gap-1 p-1", bem(null, itemType), className);

    return (
      <Option value={eventKey} onSelect={onSelect} onClick={onClick} className={combinedClassName} componentClass="span" {...rest}>
        <Icon
          icon="check"
          spacing="right"
          style={{
            opacity: eventKey === currentSort ? "1" : "0",
            marginTop: "2px",
          }}
        />
        {children}
      </Option>
    );
  }

  handleClick = (e) => {
    const { onSelect, onClick, eventKey } = this.props;
    e.preventDefault();

    if (onSelect) {
      onSelect(eventKey);
    }

    if (this.context.onMenuSelect) {
      this.context.onMenuSelect(eventKey);
    }

    if (onClick) {
      onClick(e);
    }
  };
}

CompactMenuItem.contextTypes = {
  onMenuSelect: PropTypes.func,
};

CompactMenuItem.propTypes = {
  itemType: PropTypes.oneOf(["default", "dropdown", "filter"]),
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  eventKey: PropTypes.any,
  currentSort: PropTypes.any,
  className: PropTypes.string,
  children: PropTypes.node,
};

CompactMenuItem.defaultProps = {
  itemType: "default",
};
